<template>
	<div class="pay-page">
		<!-- <div class="pay-content">
			<div class="pay-content-money">
				<span class="money">100</span>			
				<span class="sign">元</span>
			</div>
			<div class="pay-content-time">
				<span class="pay-content-time-title">剩余支付时间</span>
				<div class="pay-content-time-val">{{countDown}}</div>
			</div>
		</div>
		<div class="pay-type-list">
			<div class="pay-tip" v-if="balance<amount">余额已不足，请选择其他支付方式组合支付</div>
      <div class="pay-type-list-item" @click="type=index" :class="type==index?'pay-type-list-item-active':''" v-for="item,index in typeList" :key="index">
				<div class="pay-type-list-item-img">
					<span class="iconfont icon-weixinzhifu" :style="{color:item.color}"></span>
				</div>
				<div class="pay-type-list-item-content">
					<div class="pay-type-list-item-content-title">{{item.name}}</div>
				</div>
			</div>	
			<div class="pay-type-list-item" @click="type=index" :class="type==index?'pay-type-list-item-active':''" v-for="item,index in typeList" :key="index">
				<div class="pay-type-list-item-img">
					<span class="iconfont" :class="item.icon" :style="{color:item.color}"></span>
				</div>
				<div class="pay-type-list-item-content">
					<div class="pay-type-list-item-content-title">{{item.name}}</div>
				</div>
			</div>
			<div class="pay-type-list-item" @click="type=0" :class="type==0?'pay-type-list-item-active':''">
				<div class="pay-type-list-item-img">
					<span class="iconfont icon-yue" style="color:#fcbb74;"></span>
				</div>
				<div class="pay-type-list-item-content">
					<div class="pay-type-list-item-content-title">余额支付</div>
					<div class="pay-type-list-item-content-val">余额：¥{{balance}}</div>
				</div>
				<div class="recharge-btn" v-if="balance<ordersAmount" @click="toRecharge">充值</div>
			</div>
			<div class="pay-tip" v-if="balance<ordersAmount">余额已不足，请选择其他支付方式组合支付</div>
			<div class="pay-type-list-item" @click="type=index+1" :class="type==index+1?'pay-type-list-item-active':''" v-for="item,index in typeList" :key="index">
				<div class="pay-type-list-item-img">
					<span class="iconfont" :class="item.icon" :style="{color:item.color}"></span>
				</div>
				<div class="pay-type-list-item-content">
					<div class="pay-type-list-item-content-title">{{item.name}}</div>
				</div>
			</div>				
		</div>
		<div class="pay-btn-bg">
			<div class="pay-btn" @click="toPay" v-if="!isPaid">支付</div>
			<div class="pay-btn disable-btn" v-else>支付</div>
		</div> -->
	</div>
</template>

<script>
export default{
	data() {
		return {
			isPaid: false,
			ordersAmount: 0,
			balance: 0,
      amount: 0,
			type:0,
			navConfig: {
				navFixed: true,
				isCustomFn: true,
				btnType: 'type1'
			},
			typeList:[
				// {name:'余额支付',color:'#fcbb74',icon:'icon-yue'},
				{name:'微信支付',color:'#09bb07',icon:'icon-weixinzhifu'},
				// {name:'支付宝',color:'#02a9f1',icon:'icon-zhifubao'},
			],
			countDown: '30:00',
			maxTime: 1800,
			interval:null,
			orderInfo: {},
		}
	},
	created() {
		// let orderInfo = JSON.parse(this.$store.state.stayOrder.orderInfo);
		// orderInfo.actualAmount = orderInfo.actualAmount;
		// orderInfo.ordersAmount = orderInfo.ordersAmount;
		// this.orderInfo = orderInfo;
		// this.ordersAmount = orderInfo.ordersAmount;
		this.handleCountDown();
		// console.log('stayOrderData===', orderInfo, typeof(orderInfo.actualAmount))
	},
	methods: {
		handleCountDown() {
			this.interval = setInterval(() => {
				this.maxTime--;
				let minutes = Math.floor(this.maxTime / 60);
				let seconds = Math.floor(this.maxTime % 60);
				minutes = minutes < 10 ? '0' + minutes : minutes;
				seconds = seconds < 10 ? '0' + seconds : seconds;
				this.countDown = minutes + ":" + seconds;
				if (this.maxTime === 0) {
					clearInterval(this.interval)
				}
			}, 1000)
		},
		toRecharge(){

		},
		toPay() {
			getProvinceByName().then(res => {

			})
      return
			this.isPaid = true;
			this.$Util.appRequest({
				method: 'POST',
				header: {
					'Content-Type': 'application/json'
				},
				url: '/order/ProductOrders/submit',
				data: this.orderInfo
			}).then(res => {
				this.isPaid = false;
				if (res.code === 200) {
					// this.navigateTo('/pagesCommon/webPage?url=' + res.data.url)
					let obj = JSON.parse(res.data.url);
					this.$store.commit('setOrderNo', res.data.ordersNo)
					uni.requestPayment({
						// #ifdef MP-WEIXIN
						...obj,
						// #endif
						success: r => {
							this.$Util.showToast('支付成功')
							// this.$store.dispatch('stayOrderDataReset');
							setTimeout(() => {
								this.$store.dispatch('stayOrderDataReset');  // 删除原有数据
								this.reLaunch('/pagesCategory/accommodation/order-result');
							}, 500)
						},
						fail: err => {
							console.log(err)
							this.$Util.showToast('支付失败')
							setTimeout(() => {
								this.$store.dispatch('stayOrderDataReset');  // 删除原有数据
								this.reLaunch('/pagesCategory/accommodation/order-detail');
							}, 500)
						}
					})
				} else {
					this.$Util.showToast(res.msg)
				}
			})
		}
	},
	destoryed(){
		clearInterval(this.interval)
	}
}
</script>

<style lang="scss" scoped>
	.pay-page{
		max-width: 750px;
		height: 100%;
		position: relative;
		// padding: 0 .8rem;
    // background: #F5F5F7;
		margin: 0 auto;
		.pay-content{
			height: 10.5rem;
			width: 100%;
			@include flex();
			flex-direction: column;
			.pay-content-money{
				font-size: 1.8rem;
				font-weight: bold;
				color: #0A1629;
				.sign{
					font-size: 1.2rem;
				}
				.money{

				}
			}
			.pay-content-time{
				margin-top: .4rem;
				font-size: .6rem;
				display: flex;
				align-items: center;
				.pay-content-time-title{
					color: #222222;					
				}
				.pay-content-time-val{
					color: #47B6C7;
					margin-left: .2rem;
				}
			}
		}
		.pay-type-list{
			width: 90%;
			margin: 0 auto;
			.pay-tip{
				font-size: .6rem;
				font-weight: 300;
				color: #222222;
				margin-top: -0.2rem;
				margin-bottom: .6rem;
			}
			.pay-type-list-item{
				position: relative;
				height: 3.6rem;
				background: #FFFFFF;
				border-radius: .5rem;
				backdrop-filter: blur(10);
				margin-bottom: .6rem;
				display: flex;
				align-items: center;
				padding: 0 1rem;
				&-active{
					border: .1rem solid #47B6C7;
					backdrop-filter: blur(10);
					box-shadow: 0 0 0 .2rem #c1e2e8;
					margin: .2rem 0 .8rem 0;
				}
				&:last-child{
					margin-bottom: 0;
				}
				.recharge-btn{
					width: 160;
					height: 1.8rem;
					background: #F5F5F7;
					border-radius: .9rem;
					font-size: .8rem;
					font-weight: bold;
					color: #47B6C7;
					@include flex();
					position: absolute;
					right: .6rem;
				}
				.pay-type-list-item-img{
					.iconfont{
						font-size:1.05rem;
					}
				}
				.pay-type-list-item-content{
					margin-left: .8rem;
					&-title{
						font-size: .8rem;
						font-weight: bold;
						color: #222222;
					}
					&-val{
						font-size: .6rem;
						font-weight: 400;
						color: #999999;
					}
				}
			}
		}
		.pay-btn-bg{
			width: 100%;
			position: fixed;
			height: 4.15rem;
			background: #FFFFFF;
			box-shadow: inset 0rem -0.05rem 0rem 0rem #EEEEEE;
			span-align: center;
			left: 0;
			bottom: 0;
			.pay-btn{				
    		margin: .6rem auto;
				width: 14rem;
				height: 2rem;
				background: #47B6C7;
				border-radius: .4rem;
				font-size: .8rem;
				font-weight: bold;
				color: #FFFFFF;
				@include flex();
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/distribution/pay.vue